const doc = [({"ko":({"adminConstantHotelCheckInRequiredGuestInfoScope":({"allGuests":"투숙객 모두", "onlyRepresentative":"대표자만"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;